export default __webpack_public_path__ + "static/media/IMG-20241210-WA0023.7dbcf6e6.jpg";